import { useCallback } from 'react';
import { useDaily, useParticipantIds } from '@daily-co/daily-react';

export const HAND_RAISED_USER_DATA_KEY = 'hr';

export const useHandRaising = () => {
  const daily = useDaily();

  const handRaisedParticipants = useParticipantIds({
    filter: useCallback((participant) => 
      participant.userData?.[HAND_RAISED_USER_DATA_KEY], 
    []),
  });

  const raiseHand = useCallback(() => {
    const prevUserData = daily?.participants()?.local?.userData;

    daily.setUserData({
      ...prevUserData,
      [HAND_RAISED_USER_DATA_KEY]: new Date().toISOString(),
    });
  }, [daily]);

  const lowerHand = useCallback(() => {
    const prevUserData = {
      ...daily?.participants()?.local?.userData
    };
    delete prevUserData[HAND_RAISED_USER_DATA_KEY];

    daily.setUserData({ ...prevUserData });
  }, [daily]);

  return {
    raiseHand,
    lowerHand,
    handRaisedParticipants
  };
};

export const useHandRaisedQueue = (id) => {
  const idsWithRaisedHands = useParticipantIds({
    filter: useCallback((p) => 
      p.userData?.[HAND_RAISED_USER_DATA_KEY], 
    []),
    sort: useCallback((a, b) => {
      const aDate = a.userData?.[HAND_RAISED_USER_DATA_KEY];
      const bDate = b.userData?.[HAND_RAISED_USER_DATA_KEY];

      if (aDate < bDate) return -1;
      if (aDate > bDate) return 1;
      return 0;
    }, []),
  });

  if (idsWithRaisedHands.includes(id)) {
    return idsWithRaisedHands.indexOf(id) + 1;
  }

  return undefined;
};